// extracted by css-extract-rspack-plugin
export default {"wrapper":"nh2lsiUteuE95fS1","singleLine":"xAzCpXkQbYIeLPwx","multiLine":"FoyISRJFB_4vDCxJ","tooltip":"i4gMNgdCRZUQOw4x"};